import * as yup from "yup";

const validations = yup.object().shape({
  name: yup.string().required("Bu alan zorunludur"),
  count: yup
    .number()
    .min(1, "Minimum 1 Olmalıdır")
    .required("Bu alan zorunludur"),
});

export default validations;
